(function () {
  "use strict";
  document.addEventListener("DOMContentLoaded", function () {
    var tc = document.getElementById("tourConsole");
    var pill = document.getElementById("tcPill");
    if (!tc || !pill) return;

    function close() {
      tc.classList.remove("open");
      pill.setAttribute("aria-expanded", "false");
    }

    pill.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = tc.classList.toggle("open");
      pill.setAttribute("aria-expanded", open ? "true" : "false");
    });

    document.addEventListener("click", function (e) {
      if (tc.classList.contains("open") && !e.target.closest("#tourConsole")) close();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && tc.classList.contains("open")) close();
    });
  });
})();
